import Action from '../../../decorators/Action';
import Observable from '../../../decorators/Observable';
import StoreFieldInSession from '../../../decorators/StoreFieldInSession';
import AbstractSessionModel from '../../../models/AbstractSessionModel';

export default class FinalizeSitemapWizardData extends AbstractSessionModel {
  @Observable()
  @StoreFieldInSession()
  important_pages: string[] = [];

  constructor() {
    super();
    super.initFields();
  }

  @Action()
  setFormData(formData: { important_pages: string[] }) {
    this.important_pages = formData.important_pages;
  }

  getWizardData() {
    return {
      important_pages: this.important_pages
    };
  }

  public getSessionKey(): string {
    return 'FinalizeSitemapWizardData';
  }
}
